import axios from "axios";
import { endpoint } from "../../config/app.config";
import { clearCookie, getCookie, setParentDomainCookie } from "../../utils/cookies";

const { token, reset, sub, user } = getCookie()

export async function getNewsDetail() {
  clearCookie()
  return axios
    .get(`${endpoint}/api/news`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
}

export async function getNewsById(title) {
  clearCookie()
  return axios
    .get(`${endpoint}/api/news/${title}`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    })
}

export async function getPublication() {
  clearCookie()
  return axios
    .get(`${endpoint}/api/publication`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    })
}

export async function getPublicationById(title) {
  clearCookie()
  return axios
    .get(`${endpoint}/api/publication/${title}`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    })
}